<template>
  <v-container class="pa-0 ma-0 about-page">
    <h1 class="show-title mb-10">{{ content.title }}</h1>

    <!-- <div v-html="content.text0"></div> -->
    <div class="d-flex flex-row flex-wrap justify-space-between">
      <div class="col-12 pa-0 px-3 pb-5 d-flex flex-wrap">
        <!-- CARD 1 -->
        <div class="col-12 col-md-9 pa-0 pb-8 px-3">
          <v-card
            class="AliceBlue figures-card card-wrapper d-flex justify-space-between pa-2"
            tile
            flat
          >
            <div
              class="card-head col-6 pa-0 d-flex flex-column align-center justify-center"
            >
              <v-card-title class="card-number black--text">{{
                content.text1
              }}</v-card-title>
              <v-card-title class="card-title darkgray--text mt-2 pa-0">{{
                content.text1b
              }}</v-card-title>
            </div>

            <div
              class="card-caption col-6 pa-0 white d-flex flex-column justify-space-around"
            >
              <div class="d-flex justify-space-around">
                <div class="d-flex flex-column align-center justify-center">
                  <v-card-title class="card-number pa-0">{{
                    content.text2
                  }}</v-card-title>
                  <v-card-title class="card-title darkgray--text pa-0">{{
                    content.text2b
                  }}</v-card-title>
                </div>

                <v-divider vertical class="AliceBlue"></v-divider>

                <div class="d-flex flex-column align-center justify-center">
                  <v-card-title class="card-number pa-0">{{
                    content.text3
                  }}</v-card-title>
                  <v-card-title class="card-title darkgray--text pa-0">{{
                    content.text3b
                  }}</v-card-title>
                </div>
              </div>

              <v-divider class="AliceBlue"></v-divider>

              <div class="d-flex flex-column align-center justify-center">
                <v-card-title class="card-number pa-0">{{
                  content.text4
                }}</v-card-title>
                <v-card-title class="card-title darkgray--text pa-0">{{
                  content.text4b
                }}</v-card-title>
              </div>
            </div>
          </v-card>
        </div>

        <!-- CARD 2 -->
        <div class="col-12 col-md-3 col-4 pa-0 pb-8 px-3">
          <v-card
            class="figures-card card-wrapper d-flex justify-space-between pa-2 green"
            tile
            flat
          >
            <div
              class="card-head d-flex flex-column align-center justify-center mx-auto"
            >
              <v-card-title class="card-number white--text">{{
                content.text5
              }}</v-card-title>
              <v-card-title class="card-title white--text mt-2 pa-0">{{
                content.text5b
              }}</v-card-title>
            </div>
          </v-card>
        </div>
        <!-- CARD 3 -->
        <div class="col-12 col-md-4 pa-0 pb-8 px-3">
          <v-card
            class="figures-card card-wrapper green d-flex justify-space-between pa-2"
            tile
            flat
          >
            <div
              class="card-head d-flex flex-column align-center justify-center mx-auto"
            >
              <v-card-title class="card-number white--text">{{
                content.text6
              }}</v-card-title>
              <v-card-title class="card-title white--text mt-2 pa-0">{{
                content.text6b
              }}</v-card-title>
            </div>
          </v-card>
        </div>
        <!-- CARD 4 -->
        <div class="col-12 col-md-4 pa-0 pb-8 px-3">
          <v-card
            class="AliceBlue figures-card card-wrapper d-flex justify-space-between pa-2"
            tile
            flat
          >
            <div
              class="card-head d-flex flex-column align-center justify-center mx-auto"
            >
              <v-card-title class="card-number black--text">{{
                content.text7
              }}</v-card-title>
              <v-card-title class="card-title darkgray--text mt-2 pa-0">{{
                content.text7b
              }}</v-card-title>
            </div>
          </v-card>
        </div>

        <!-- CARD 5 -->
        <div class="col-12 col-md-4 pa-0 pb-8 px-3">
          <v-card
            class="aqua figures-card card-wrapper d-flex justify-space-between pa-2"
            tile
            flat
          >
            <div
              class="card-head col-12 pa-0 d-flex flex-column align-center justify-center"
            >
              <v-card-title class="card-number white--text">{{
                content.text8
              }}</v-card-title>
              <v-card-title class="card-title white--text mt-2 pa-0"
                >{{ content.text8b }} (70% INTERNATIONAL)</v-card-title
              >
            </div>

            <!--             <div
              class="card-caption col-6 pa-0 lightgray d-flex flex-column justify-space-around"
            >
              <div class="d-flex flex-column align-center justify-center">
                <v-card-title class="card-number pa-0">{{
                  content.text9
                }}</v-card-title>
                <v-card-title class="card-title darkgray--text pa-0">{{
                  content.text9b
                }}</v-card-title>
              </div>
            </div> -->
          </v-card>
        </div>
      </div>
    </div>
    <div align="center"><h4>14 / 01 / 2021</h4></div>
  </v-container>
</template>

<script>
export default {
  name: 'Figures',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.figures-card {
  border: 1px solid #878a8c !important;
  height: 180px;

  .card-head {
    .card-number {
      font-size: 60px;
    }
    .card-title {
      font-size: 14px;
    }
  }

  .card-caption {
    .card-number {
      font-size: 21px;
    }
    .card-title {
      font-size: 12px;
    }
  }

  .card-number {
    font-family: $heading-font-family;
    font-weight: bold;
    text-transform: uppercase;
    overflow-wrap: normal;
    word-break: normal;
    text-align: center;
  }

  .card-title {
    font-family: $heading-font-family;
    font-weight: normal;
    text-transform: uppercase;
    overflow-wrap: break-word;
    word-break: keep-all;
    text-align: center;
  }
}
</style>
